
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificate",
      function () {
        return require("private-next-pages/certificate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificate"])
      });
    }
  